import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

export interface IErrorsStore {
  isAuthorized: boolean;
  setAuthorization(isAuthorized: boolean): void;
}

export namespace IErrorsStore {
  export const $: interfaces.ServiceIdentifier<IErrorsStore> = Symbol('ERRORS_STORE');
}

@injectable()
export class ErrorsStore implements IErrorsStore {
  isAuthorized: boolean = true;

  constructor() {
    makeObservable(this, {
      isAuthorized: observable,
      setAuthorization: action,
    });
  }

  setAuthorization(isAuthorized: boolean): void {
    this.isAuthorized = isAuthorized;
  }
}
